import { _ } from "../../polyglot/polyglot.js";
import { getCurrencies } from "../../helpers/currency-formatting-util.js";
import { select } from "../../elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

const allCurrencies = getCurrencies();

const items = allCurrencies.map((eachCurrency) => ({
	label: `${eachCurrency.iso4217} (${eachCurrency.symbol})`,
	value: eachCurrency,
}));

/**
 * `CurrencyPicker` is a section in the
 * `selectDataStepWidget` wizard step to choose the currency.
 */
export default class CurrencyPicker extends Widget {
	selectCurrency(locale) {
		if (!locale) return;

		this._selectedCurrency = this._getCurrencyFromLocale(locale);
		this.update();
	}

	getCurrency() {
		return this._selectedCurrency.locales[0];
	}

	renderContentOn(html) {
		html.div(
			{
				klass: "form-group chart-of-account",
				"data-test": "currency-picker",
			},
			html.label({ klass: "control-label col-sm-4" }, _("Currency")),
			html.div({ klass: "col-sm-8" }, this._makeCurrencyDropdown()),
		);
	}

	_makeCurrencyDropdown() {
		this._selectedCurrency ??= items[0];

		return select({
			items,
			selected: this._selectedCurrency,
			onChange: (value) => (this._selectedCurrency = value),
		});
	}

	_getCurrencyFromLocale(locale) {
		const countryCode = this._getCountryCodeFromLocale(locale);

		return allCurrencies.find((aCurrency) =>
			aCurrency.locales.some(
				(aLocale) =>
					countryCode === this._getCountryCodeFromLocale(aLocale),
			),
		);
	}

	_getCountryCodeFromLocale(locale) {
		return locale.split("-")[1];
	}
}
